@if (ministry.subscribed) {
  <button mat-flat-button color="primary" (click)="unsubscribe()">Following</button>
}
@if (ministry.unsubscribed) {
  <button mat-stroked-button color="primary" mat-button (click)="subscribe()">Follow</button>
}
@if (ministry.localChurchSubscribed) {
  <button mat-flat-button color="primary" (click)="unsubscribeLocalChurch()">Local Church</button>
}
@if (ministry.localChurchUnsubscribed) {
  <button mat-stroked-button color="primary" (click)="subscribeLocalChurch()">Local Church</button>
}
<!--<button mat-stroked-button color="primary" *ngIf="ministry.localChurchUnsubscribed" (click)="subscribeLocalChurch()" style="margin-left: 16px;">Local Church</button>-->
